import scheduledTasksService from '../../services/scheduledTasksService'

class ScheduledTasksController {
  createScheduledTask = scheduledTasksService.createScheduledTask
}

export default new ScheduledTasksController()
 


// WEBPACK FOOTER //
// ../src/controllers/scheduledTasksController/scheduledTasksController.js